"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const loading_overlay_1 = __importDefault(require("./loading_overlay"));
const styled_1 = __importDefault(require("../../styles/styled"));
const styles_1 = require("../../styles");
function ListView(props) {
    const { columns, data, loading = false, gridTemplateColumns, buildRowTestId = () => { }, onRowClick, canRowClick, linkTo, } = props;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [loading && (0, jsx_runtime_1.jsx)(loading_overlay_1.default, {}), !loading && ((0, jsx_runtime_1.jsx)(ListViewGrid, Object.assign({ "data-testid": props['data-testid'], columns: gridTemplateColumns }, { children: data.map(record => {
                    var _a;
                    const handleRowClickProps = {};
                    const clickable = (_a = canRowClick === null || canRowClick === void 0 ? void 0 : canRowClick(record)) !== null && _a !== void 0 ? _a : !!onRowClick;
                    if (clickable && !!onRowClick) {
                        handleRowClickProps.tabIndex = 0;
                        handleRowClickProps.role = 'button';
                        handleRowClickProps.onClick = () => {
                            onRowClick(record);
                        };
                        handleRowClickProps.onKeyDown = (e) => {
                            if (e.key === 'Enter') {
                                onRowClick(record);
                            }
                        };
                    }
                    const RowContainer = ({ children }) => {
                        return linkTo && canRowClick && canRowClick(record) ? ((0, jsx_runtime_1.jsx)(ListViewRowLink, Object.assign({ onClick: () => {
                                linkTo(record);
                            } }, { children: children }))) : ((0, jsx_runtime_1.jsx)(ListViewRow, { children: children }));
                    };
                    return ((0, jsx_runtime_1.jsx)(RowContainer, Object.assign({ "data-testid": buildRowTestId(record) }, { children: columns.map(column => {
                            const handleCellClickProps = {};
                            if (column.onCellClick) {
                                handleCellClickProps.tabIndex = 0;
                                handleCellClickProps.role = 'button';
                                handleCellClickProps.onClick = (e) => {
                                    column.onCellClick(record, e);
                                };
                                handleCellClickProps.onKeyDown = (e) => {
                                    if (e.key === 'Enter') {
                                        column.onCellClick(record, e);
                                    }
                                };
                            }
                            return ((0, jsx_runtime_1.jsx)(ListViewCell, Object.assign({ className: 'list-view__cell', "data-testid": `${buildRowTestId(record)}-cell-${column.key}` }, handleCellClickProps, handleRowClickProps, { children: column.render(record) }), column.key));
                        }) }), record.key));
                }) })))] }));
}
exports.ListView = ListView;
const ListViewGrid = styled_1.default.div(({ columns }) => ({
    display: 'grid',
    gridTemplateColumns: columns !== null && columns !== void 0 ? columns : '1fr auto auto',
    borderWidth: '0 1px',
    borderStyle: 'solid',
    borderColor: styles_1.Theme.colors.grey10,
}));
const ListViewRowLink = (0, styled_1.default)('a')(({ theme }) => ({
    display: 'contents',
    ':hover > .list-view__cell': {
        backgroundColor: theme.colors.lightBlue,
        cursor: 'pointer',
    },
}));
const ListViewRow = styled_1.default.div(({ theme }) => ({
    display: 'contents',
    ':hover > .list-view__cell': {
        backgroundColor: theme.colors.lightBlue,
    },
}));
const ListViewCell = styled_1.default.div(({ theme, onClick }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '88px',
    padding: `5px ${theme.space[4]}px`,
    fontFamily: theme.text.bodyFontFamily,
    fontSize: theme.text.size.medium,
    color: theme.colors.grey90,
    verticalAlign: 'middle',
    wordBreak: 'break-word',
    backgroundColor: 'none',
    ':hover': {
        cursor: onClick ? 'pointer' : undefined,
    },
    borderBottom: `1px solid ${theme.colors.grey10}`,
}));
//# sourceMappingURL=list_view.js.map